module.exports = __webpack_public_path__ + "static/iphone-shell-f2da2052d8efee47359d1aa906f94fc9.png";